import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../../components/global/Button';
import EmailPhoneInput, {
  INPUT_TYPE,
} from '../../../../../../../components/global/EmailPhoneInput';
import WaldoSpeechBubble from '../../../../../../../components/global/WaldoSpeechBubble';
import { AUTH_TYPE } from '../../../../../../../constants/auth';
import { isValidEmail } from '../../../../../../../util/email';
import { isValidPhone, parsePhone } from '../../../../../../../util/phone';

const propTypes = {
  loading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

// Collects a contact method when the QR code has none on file, so a pin can be
// sent to it. The entered contact becomes the account the identity is claimed
// with, and the QR code's marketing account is linked to it afterwards.
const ContactEntryStep = ({ loading, onSubmit }) => {
  const [contact, setContact] = useState('');
  const [inputType, setInputType] = useState(INPUT_TYPE.PHONE);
  const [error, setError] = useState('');

  const inputIsPhone = inputType === INPUT_TYPE.PHONE;

  const handleSubmit = event => {
    event.preventDefault();

    if (inputIsPhone) {
      if (!isValidPhone(parsePhone(contact))) {
        setError('Please enter a valid mobile number');
        return;
      }

      onSubmit({ method: AUTH_TYPE.PHONE, phoneNumber: contact });
      return;
    }

    if (!isValidEmail(contact)) {
      setError('Please enter a valid email address');
      return;
    }

    onSubmit({ method: AUTH_TYPE.EMAIL, emailAddress: contact });
  };

  return (
    <Fragment>
      <WaldoSpeechBubble className="w-100-i mx-0 mb-2 text-sm" position="right">
        We don&apos;t have a way to reach you yet. Leave your mobile number or
        email address and we&apos;ll send you a pin code to see your photos.
      </WaldoSpeechBubble>
      <div className="roster-qr-code-contact-entry-step">
        <h2 className="text-center mb-4">How can we reach you?</h2>

        <form onSubmit={handleSubmit}>
          <EmailPhoneInput
            id="roster-qr-code-contact"
            name="contact"
            className="mb-3"
            autoFocus
            value={contact}
            placeholder={
              inputIsPhone ? 'Enter mobile number' : 'Enter email address'
            }
            defaultInputType={INPUT_TYPE.PHONE}
            onInputTypeChange={setInputType}
            onChange={value => {
              setContact(value);
              setError('');
            }}
          />

          {error && <p className="text-danger small mb-3">{error}</p>}

          <Button
            type="submit"
            disabled={loading || !contact}
            loading={loading}
            className="btn-primary w-100 mb-3"
            btnSize="lg"
          >
            Send my pin code
          </Button>

          <p className="text-muted small text-center mb-0">
            By continuing you agree to <a href="/terms">Terms of Use</a> &{' '}
            <a href="/privacy">Privacy Policy</a>. <br />
            This site is protected by reCAPTCHA.
          </p>
        </form>
      </div>
    </Fragment>
  );
};

ContactEntryStep.propTypes = propTypes;

export default ContactEntryStep;
